export var DistributorStatuses;
(function (DistributorStatuses) {
    DistributorStatuses["AVAILABLE"] = "AVAILABLE";
    DistributorStatuses["UNAVAILABLE"] = "UNAVAILABLE";
    DistributorStatuses["AVAILABLE_STOCK_RISK"] = "AVAILABLE_STOCK_RISK";
    DistributorStatuses["AVAILABLE_NO_STOCK"] = "AVAILABLE_NO_STOCK";
})(DistributorStatuses || (DistributorStatuses = {}));
export var ProductTypes;
(function (ProductTypes) {
    ProductTypes["SIMPLE"] = "SIMPLE";
    ProductTypes["COMBO"] = "COMBO";
})(ProductTypes || (ProductTypes = {}));
//# sourceMappingURL=product.js.map